// removed by extract-text-webpack-plugin
module.exports = {"content":"_2sRzFInsJzC61UEh0HIk06"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Content.less
 ** module id = 856
 ** module chunks = 0
 **/